import { useTooltip } from '@visx/tooltip';
import { UseTooltipParams } from '@visx/tooltip/lib/hooks/useTooltip';
import {
  Dispatch,
  ReactNode,
  SetStateAction,
  createContext,
  useMemo,
  useState,
} from 'react';

export type Props = {
  children: ReactNode;
};

export type TooltipContextValue = UseTooltipParams<JSX.Element | null> & {
  boundsRef: SVGRectElement | null;
  setBoundsRef: Dispatch<SetStateAction<SVGRectElement | null>>;
};

const TooltipContext = createContext<TooltipContextValue | null>(null);

export const TooltipContextProvider = ({ children }: Props) => {
  const [boundsRef, setBoundsRef] = useState<SVGRectElement | null>(null);

  const visXTooltip = useTooltip<JSX.Element | null>({
    tooltipData: null,
  });

  const value = useMemo<TooltipContextValue>(
    () => ({
      ...visXTooltip,
      boundsRef,
      setBoundsRef,
    }),
    [boundsRef, visXTooltip]
  );

  return (
    <TooltipContext.Provider value={value}>{children}</TooltipContext.Provider>
  );
};

export default TooltipContext;
